import React, { useCallback } from 'react';
import type { DocsVerificationLivenessTagErrorEnum } from '@models/enums';
import type { FileWithPreview } from '@models/types';

import { LivenessProcess } from './step/liveness-process';
import type {
    FaceDetectResult,
    LivenessProps,
    LivenessUploadMetadata,
} from './step/liveness-process/types';
import { LivenessContainer } from './styles';

export const Liveness: React.FC<LivenessProps> = ({
    onFileChange,
    onSubmit,
    onClose,
    errorProceedText,
    ...props
}) => {
    const handleSubmit = useCallback(
        async (isFailedVerification?: boolean) => {
            const result = await onSubmit?.(isFailedVerification);

            return !!result;
        },
        [onSubmit],
    );

    const handleFileChange = useCallback(
        async (
            file: FileWithPreview | FileWithPreview[],
            tag?: DocsVerificationLivenessTagErrorEnum,
            faceDetectResult?: FaceDetectResult,
            metadata?: LivenessUploadMetadata,
        ) => {
            const fileState = await onFileChange(file, tag, faceDetectResult, metadata);

            return fileState;
        },
        [onFileChange],
    );

    return (
        <LivenessContainer>
            <LivenessProcess
                onFileChange={handleFileChange}
                {...props}
                onSubmit={handleSubmit}
                onClose={onClose}
                className='liveness-process-container'
                errorProceedText={errorProceedText}
            />
        </LivenessContainer>
    );
};
